<template>
  <tr v-if="linha.divider" class="table-tr">
    <td
      :colspan="maximoDeColunas || 1"
      :style="linha.style"
      :class="class_column"
    >
      <div class="d-flex align-center" style="height: 12px">
        <span class="font-weight-medium font-12">
          <slot :name="nomeSlotLinha" :titulo="linha.titulo">{{linha.titulo}}</slot>
        </span>

        <div v-if="!linha.desativar_slot" class="ml-1px pr-1">
          <slot :name="`${nomeSlotLinha}.append`" />
        </div>

        <v-divider />
      </div>
    </td>
  </tr>
  <tr v-else class="table-tr">
    <slot
      :name="nomeSlotLinha"
      :linha="linha"
    >
      <td
        v-for="(coluna, index) in linha.colunas"
        :key="index"
        :colspan="coluna.colspan || 1"
        :rowspan="coluna.rowspan || 1"
        :class="class_column"
        class="text-no-wrap"
      >
        <slot
          :name="`coluna.${coluna.valor}`"
          :coluna="coluna"
        >
          <p id="titulo-coluna" class="ma-0 font-weight-medium">
            <slot
              :name="`coluna.titulo.${coluna.valor}`"
              :coluna="coluna"
              :texto="coluna.texto"
            >
              {{coluna.texto}}
            </slot>
          </p>

          <p id="valor-coluna" class="ma-0">
            <slot
              :name="`coluna.valor.${coluna.valor}`"
              :coluna="coluna"
              :valor="getValorColuna(coluna)"
            >
              <template v-if="coluna.formatar">
                {{ Helpers.formatarValor(getValorColuna(coluna)) }}
              </template>
              <template v-else-if="coluna.formatarDinheiro">
                {{ Helpers.formatarValorMonetario(getValorColuna(coluna)) }}
              </template>
              <template v-else>
                {{getValorColuna(coluna)}}
              </template>

              <span v-if="coluna.append">{{ coluna.append }}</span>
            </slot>
          </p>
        </slot>
      </td>
    </slot>
  </tr>
</template>

<script>
export default {
  name: "LinhaTabelaDetalhesProdutos",
  props: {
    linha: {
      type: Object,
      required: true
    },
    dados: {
      type: Object,
      required: false
    },
    maximoDeColunas: Number,
    class_column: {
      type: String,
      default: ""
    }
  },
  computed: {
    nomeSlotLinha () {
      return (this.linha.nome && this.linha.nome.length > 0)
        ? `${this.linha.nome}`
        : 'default'
    }
  },
  methods: {
    getValorColuna (coluna){
      if ([undefined, null].includes(this.dados[coluna.valor])) {
        return '';
      }

      return this.dados[coluna.valor];
    }
  }
}
</script>

<style scoped>
.table-tr td {
  color: #1a1a1a;
  padding: 0;
  margin: 0;
  font-size: 0.725rem;
}
</style>
